const styles = {
	// original square was 140px width, 78px height
	squareWidth: '196px',
	squareHeight: '109px',
	squareBackgroundColor: '#2f0dd3',
	categoryColor: 'white',
	categoryFont: 'HelveticaInserat',
	categoryFontSize: '30px',
	categoryAuthorFont: 'Swiss911Compressed',
	categoryAuthorFontSize: '21px',
	dollarColor: '#CEA259',
	dollarFont: 'Swiss911ExtraCompressed',
	dollarNumberFontSize: '90px',
	dollarSignFontSize: '70px',
	questionColor: 'white',
	questionFont: 'Korinna',
	questionFontSize: '48px',
	questionFontSizeLines: '24px',
	scoreFont: 'Univers',
	scoreFontSize: '36px',
	scoreColor: 'white',
	scoreColorNegative: 'rgb(236, 33, 55)',
	scoreBackground: '#0B198E',
	teamAFont: 'RockSalt',
	teamBFont: 'HomemadeApple',
	teamFontSize: '30px',
	teamBackground: 'linear-gradient(180deg, rgba(28,58,155,1) 1%, rgba(28,59,149,1) 50%, rgba(11,30,103,1) 100%)',
	shadow0: '0px 0px 2px #000000',
	shadow1: '1px 1px 0px #000000',
	shadow2: '1px 1px 0px #000000, 2px 2px 0px #000000',
	shadow3: '1px 1px 0px #000000, 2px 2px 0px #000000, 3px 3px 0px #000000',
	shadow4: '1px 1px 0px #000000, 2px 2px 0px #000000, 3px 3px 0px #000000, 4px 4px 0px #000000',
};

export default styles;
